import { Box } from 'native-base';
import { FC, useCallback, useEffect, useState } from 'react';
import { SpringEnrollmentForm } from '../../components/auth/SpringEnrollmentForm';
import { AppStackScreenWithNavProps } from '../../navigation/AppNavigation';
import { useAppDispatch, useAppSelector } from '../../store';
import { registrationActions } from '../../store/actions';
import { nativeAlert } from '../../utils/ui';
import { RegistrationStatus } from '../../constants/Registration';

export const SpringEnrollmentScreen: FC<AppStackScreenWithNavProps<'SpringEnrollment'>> = ({ navigation }) => {
  const dispatch = useAppDispatch();

  const { error: registrationError } = useAppSelector((state) => state.registrations);
  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    if (registrationError) {
      dispatch(registrationActions.updateError({ error: null }));

      // Provide context-aware error messages
      const isPending = currentUser?.registration?.status === RegistrationStatus.PENDING;
      const errorTitle = isPending ? 'Unable to Complete Enrollment' : 'Spring Enrollment Unsuccessful';
      const errorMessage = isPending
        ? 'Your account is still being set up. Please pull down to refresh the home screen and try again in a few minutes.'
        : registrationError;

      nativeAlert(errorTitle, errorMessage);
    }
  }, [registrationError, currentUser?.registration?.status]);

  const handleSubmit = useCallback(async () => {
    setLoading(true);
    setDisabled(true);

    try {
      await dispatch(registrationActions.submitSpringEnrollment()).unwrap();
      await nativeAlert(
        'Success!',
        'Spring enrollment has been submitted.  Your enrollment will be processed shortly.',
      );
      navigation.goBack();
    } finally {
      setLoading(false);
      setDisabled(false);
    }
  }, []);

  return (
    <Box flex={1}>
      <SpringEnrollmentForm loading={loading} disabled={disabled} onSubmit={() => handleSubmit()} />
    </Box>
  );
};
